import { VcsProvider } from "types/generated";

import {
  LogoAzure,
  LogoAzureColored,
  LogoBitbucket,
  LogoBitbucketColored,
  LogoCursor,
  LogoCursorColored,
  LogoRawGit,
  LogoGithub,
  LogoGitlab,
  LogoGitlabColored,
  LogoShowcase,
  LogoSpacelift,
  LogoSpaceliftColored,
  Package,
} from "../components/icons/generated";

export const VCS_PROVIDERS_ICONS = {
  [VcsProvider.AzureDevops as string]: LogoAzure,
  [VcsProvider.BitbucketCloud as string]: LogoBitbucket,
  [VcsProvider.BitbucketDatacenter as string]: LogoBitbucket,
  [VcsProvider.Github as string]: LogoGithub,
  [VcsProvider.GithubEnterprise as string]: LogoGithub,
  [VcsProvider.Gitlab as string]: LogoGitlab,
  [VcsProvider.Origin as string]: LogoCursor,
  [VcsProvider.Showcase as string]: LogoShowcase,
  [VcsProvider.Git as string]: LogoRawGit,
  [VcsProvider.Spacelift as string]: LogoSpacelift,
  [VcsProvider.Blob as string]: Package,
};

export const VCS_PROVIDERS_COLORED_ICONS = {
  [VcsProvider.AzureDevops as string]: LogoAzureColored,
  [VcsProvider.BitbucketCloud as string]: LogoBitbucketColored,
  [VcsProvider.BitbucketDatacenter as string]: LogoBitbucketColored,
  [VcsProvider.Github as string]: LogoGithub,
  [VcsProvider.GithubEnterprise as string]: LogoGithub,
  [VcsProvider.Gitlab as string]: LogoGitlabColored,
  [VcsProvider.Origin as string]: LogoCursorColored,
  [VcsProvider.Showcase as string]: LogoShowcase,
  [VcsProvider.Spacelift as string]: LogoSpaceliftColored,
  [VcsProvider.Blob as string]: Package,
};
